const FEATURES = {
  UNLIMITED_LINKS: 'UNLIMITED_LINKS',
  SOCIAL_ICONS: 'SOCIAL_ICONS',
  UNIQUE_QR_CODE: 'UNIQUE_QR_CODE',
  EMBED_SOUNDCLOUD: 'EMBED_SOUNDCLOUD',
  EMBED_SPOTIFY: 'EMBED_SPOTIFY',
  EMBED_YOUTUBE: 'EMBED_YOUTUBE',
  EMBED_TWITTER: 'EMBED_TWITTER',
  EMBED_CALENDLY: 'EMBED_CALENDLY',
  EMBED_VIMEO: 'EMBED_VIMEO',
  EMBED_TYPE_FORM: 'EMBED_TYPE_FORM',
  EMBED_ACAST: 'EMBED_ACAST',
  EMBED_AMAZON_BOOKS: 'EMBED_AMAZON_BOOKS',
  EMBED_GOOGLE_MAPS: 'EMBED_GOOGLE_MAPS',
  FILE_UPLOAD: 'FILE_UPLOAD',
  ARTICLE_TEMPLATE: 'ARTICLE_TEMPLATE',
  STEP_BY_STEP_GUIDES: 'STEP_BY_STEP_GUIDES',
  LIST_TEMPLATES: 'LIST_TEMPLATES',
  PODCAST_AND_AUDIO_TEMPLATES: 'PODCAST_AND_AUDIO_TEMPLATES',
  VIDEO_TEMPLATE: 'VIDEO_TEMPLATE',
  COURSE_BUILDER: 'COURSE_BUILDER',
  DIGITAL_ITEM_TEMPLATE: 'DIGITAL_ITEM_TEMPLATE',
  DIGITAL_EVENT_TEMPLATE: 'DIGITAL_EVENT_TEMPLATE',
  COLLECT_TIPS: 'COLLECT_TIPS',
  CREATE_AND_SELL_MEMBERSHIP_AND_SUBSCRIPTIONS: 'CREATE_AND_SELL_MEMBERSHIP_AND_SUBSCRIPTIONS',
  SELL_DIGITAL_ITEMS: 'SELL_DIGITAL_ITEMS',
  SELL_DIGITAL_EVENTS: 'SELL_DIGITAL_EVENTS',
  SELL_A_COURSE: 'SELL_A_COURSE',
  CAPTURE_EMAILS: 'CAPTURE_EMAILS',
  SUBSCRIBER_AND_SUPPORTER_CONTACTS: 'SUBSCRIBER_AND_SUPPORTER_CONTACTS',
  PAYMENTS_WITH_STRIPE: 'PAYMENTS_WITH_STRIPE',
  HEADERS: 'HEADERS',
  LINK_THUMBNAILS_AND_ICONS: 'LINK_THUMBNAILS_AND_ICONS',
  PRESET_THEMES: 'PRESET_THEMES',
  CUSTOM_PROFILE_IMAGE_NAME_AND_BIO: 'CUSTOM_PROFILE_IMAGE_NAME_AND_BIO',
  CUSTOM_BACKGROUND_COLOR: 'CUSTOM_BACKGROUND_COLOR',
  UPLOAD_CUSTOM_BACKGROUND_IMAGE: 'UPLOAD_CUSTOM_BACKGROUND_IMAGE',
  PREMIUM_BUTTON_AND_FONT_STYLES: 'PREMIUM_BUTTON_AND_FONT_STYLES',
  HIDE_TRYB_LOGO: 'HIDE_TRYB_LOGO',
  INDIVIDUAL_LINK_ANALYTICS: 'INDIVIDUAL_LINK_ANALYTICS',
  DEVICE_BASED_ANALYTICS: 'DEVICE_BASED_ANALYTICS',
  LOCATION_BASED_ANALYTICS: 'LOCATION_BASED_ANALYTICS',
  REFERRER_BASED_ANALYTICS: 'REFERRER_BASED_ANALYTICS',
  OVERALL_PAGE_PERFORMANCE_ANALYTICS: 'OVERALL_PAGE_PERFORMANCE_ANALYTICS',
  SUBSCRIBER_AND_SUPPORTER_ANALYTICS: 'SUBSCRIBER_AND_SUPPORTER_ANALYTICS',
  EMAIL_CAPTURE_ANALYTICS: 'EMAIL_CAPTURE_ANALYTICS',
  REVENUE_ANALYTICS: 'REVENUE_ANALYTICS',
  VIEW_CUSTOM_DOMAIN_RANGE: 'VIEW_CUSTOM_DOMAIN_RANGE',
  LIVE_CHAT_SUPPORT: 'LIVE_CHAT_SUPPORT',
  CREATOR_RESOURCES: 'CREATOR_RESOURCES',
  CREATOR_BUSINESS_SCHOOL_COURSES: 'CREATOR_BUSINESS_SCHOOL_COURSES',
  GROWTH_AND_CONTENT_CONSULTANT: 'GROWTH_AND_CONTENT_CONSULTANT',
  MAILCHIMP_INTEGRATION: 'MAILCHIMP_INTEGRATION',
  PEER_TO_PEER_SUPPORT: 'PEER_TO_PEER_SUPPORT',
  GROUP_DISCUSSIONS_AND_DIRECT_MESSAGING: 'GROUP_DISCUSSIONS_AND_DIRECT_MESSAGING',
  COMMUNITY_EVENTS_AND_ONLINE_TRYB_MEET_UPS: 'COMMUNITY_EVENTS_AND_ONLINE_TRYB_MEET_UPS',
  PRODUCT_DEVELOPMENT_HELP_SHAPE_THE_FUTURE_OF_TRYB: 'PRODUCT_DEVELOPMENT_HELP_SHAPE_THE_FUTURE_OF_TRYB',
  BE_FEATURED_ACROSS_TRYBS_BLOG_NEWSLETTERS_AND_SOCIALS: 'BE_FEATURED_ACROSS_TRYBS_BLOG_NEWSLETTERS_AND_SOCIALS',
  BECOME_A_TRYB_CHIEF: 'BECOME_A_TRYB_CHIEF',
};

export default FEATURES;
